import { LanguageContextType } from "@/lib/main";
import { createContext } from "react";

const LanguageContext = createContext<LanguageContextType | null>(null);

export default LanguageContext;
